<template>
    <templateBase
        module-name="Configurações"
        :title="pageInfos.title"
        :subtitle="pageInfos.subtitle"
        icon-menu-card="fal fa-cog"
    >
        <template #sidebar-left>
            <ui-menu-slider :menu="menu" :menu-active="pageInfos.menu" :permissions="userPermissions" />
        </template>
        <template #page>
            <div class="grid-page" :style="uiIframe">
                <router-view />
            </div>
        </template>
    </templateBase>
</template>

<script>
	import { uiMenuSlider } from '@/components/ui'
	import helpers from '@/mixins/helpers'
	import { s3Filesystem } from '@/services/axios'
	import { storage } from '@/services/storage'
	import templateBase from '@/templates/page-configurations'
	import { makeMenuConfigurations } from './util/menu'

	export default {
		name: 'ui-configurations-util',

		components: { templateBase, uiMenuSlider },

		mixins: [helpers],

		data() {
			return {
				pageInfos: {},
				s3ActionUrls: [],
				userPermissions: null
			}
		},

		computed: {
			/**
			 * prop computada que muda o sub-menu das 'Configurações Avançadas' de acordo com as @param {String} action_urls action_urls recebidas do serviço do s3
			 */
			menu() {
				return makeMenuConfigurations(this.s3ActionUrls, this.userPermissions)
			},
			/**
			 * verifica se a rota está em "acoes", nesse caso vai ser um iframe do painel legado
			 */
  		uiIframe() {
  		  return this.$route.path.includes("/acoes/") ? 'max-width:100%' : 'max-width:700px'
  		}
		},

		watch: {
			$route(to) {
				this.pageInfos = to.meta.infos
			},
		},

		created() {
			this.pageInfos = this.$route.meta.infos;
			const { permissions } = JSON.parse(storage.get('user_logged'))
			this.userPermissions = JSON.parse(permissions);

			s3Filesystem.getAdvancedConfigs()
				.then(response => {
					this.s3ActionUrls = response.data.url_actions;
				})
				.catch(error => {
					if (error?.data?.msg) this.$toastr.e(error.data.msg)
				})
		},

		methods: {
			link (info) {
				let params = ''

				if (info.subtitle == 'Configurações Gerais') {
					switch (info.menu) {
						case 'clientes':
							params = 'configuracao/clientes'
							storage.remove('configuration_page')
							break
						case 'clube':
							params = 'configuracao/clube'
							storage.remove('configuration_page')
							break
					}
					return params
				} else {
					switch (info.subtitle) {
						case 'Campos Obrigatórios':
							params = 'configuracao/proposta'
							storage.remove('configuration_page')
							break
						case 'Permissões':
							params = 'configuracao/clientes'
							storage.set('configuration_page', 'Permissões')
							break
						case 'Perfis Dinâmicos':
							params = 'configuracao/usuarios'
							storage.remove('configuration_page')

							break
						case 'Grupos de Usuários':
							params = 'configuracao/grupos'
							storage.remove('configuration_page')

							break
					}
					return params
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
.grid-page
	width: 100%
</style>